/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".required-wrapper[_ngcontent-%COMP%]{border-top:unset;border-right:unset;border-bottom:unset}.required-wrapper-invalid[_ngcontent-%COMP%]{border-left:5px solid #ca4855}.required-wrapper-valid[_ngcontent-%COMP%]{border-left:5px solid transparent}"];
export { styles as styles };
